<div class="m-notification-list">
	<div class="m-notification-list__content">
		@for (notification of notifications$ | async; track notification.id) {
			<a-notification-message
				class="m-notification-list__message"
				[ngClass]="{
					'm-notification-list__message--enter': notification.status === 'in',
					'm-notification-list__message--exit': notification.status === 'out'
				}"
				[id]="notification.id"
				[title]="notification.title"
				[message]="notification.message"
				[mode]="notification.mode"
				[expiration]="notification.expiration"
				[closable]="notification.closable"
				(closed)="notificationClosed(notification.id)"
			></a-notification-message>
		}
	</div>
</div>
